import React from 'react';
import { useSelector } from "react-redux";
import { ArcButton, ArcDialog, ArcStack, ArcText } from "@src/core/ui";
import { selectConfirm } from '@src/core/controllers/confirm-controller/redux';
import { useConfirm } from '@src/core/controllers/confirm-controller/hooks';

const Confirm: React.FC = () => {
  const { open, title, description } = useSelector(selectConfirm);
  const { okCallback, noCallback } = useConfirm();

  return (
    <ArcDialog open={open} onClose={noCallback}>
      <ArcStack spacing={2} marginTop={ title ? -3 : 0} sx={{ maxWidth: 400 }}>
        {title && <ArcText.h5>{title}</ArcText.h5>}
        <ArcText.h6 color={title ? "text.secondary" : "text.primary"}> {description ?? 'Are you sure you want to confirm?'} </ArcText.h6>
        <ArcStack direction='row' spacing={1} justifyContent='flex-end'>
          <ArcButton.tertiary onClick={noCallback}> Cancel </ArcButton.tertiary>
          <ArcButton.brand onClick={okCallback}> Ok </ArcButton.brand>
        </ArcStack>
      </ArcStack>
    </ArcDialog>
  );
};

export default Confirm;